<template>
    <!-- Mirrors the artifacts card (ChatDetail/artifacts/ChatAgentToolArtifact.vue): a neutral
         file tile, title + meta, and a right-aligned neutral action. -->
    <BaseCard as="div" padding="sm" radius="lgr" class="flex w-full max-w-[600px] items-center gap-3 text-left" data-testid="role-play-recap-card">
        <span class="icon" aria-hidden="true"><i class="bi bi-file-text-fill"></i></span>
        <span class="min-w-0 flex-1">
            <span class="nadia-chat-bold block truncate text-ink">{{ t("chat.rolePlaySummary.title") }}</span>
            <span class="block scaffold-details-small text-ink-muted">{{ t("chat.rolePlaySummary.subtitle") }}</span>
        </span>
        <BaseLink
            :href="`/role-play/summary/${rolePlayHashid}/`"
            class="base-btn-neutral base-btn-sm shrink-0"
            :aria-label="t('chat.rolePlaySummary.viewAriaLabel')"
            preserve-scroll>
            {{ t("chat.rolePlaySummary.view") }}
        </BaseLink>
    </BaseCard>
</template>

<script setup>
import BaseCard from "~vue/components/BaseCard.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const props = defineProps({
    data: { type: Object, required: true },
    messageId: { type: Number, required: true },
    lineIdx: { type: Number, required: true },
});

const rolePlayHashid = computed(() => props.data.action_params?.role_play_hashid ?? props.data.action_params?.role_play_id);
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    /* Neutral tile, same as the artifacts card: the icon labels the recap, it is not an action. */
    .icon {
        @apply flex size-9 shrink-0 items-center justify-center rounded-lg bg-surface-sunken text-ink-muted;
    }
}
</style>
